
import Vue, { PropType } from 'vue'
import {Project, ProjectPage} from '@/model/Project'
import ConfirmSimple from '@/components/ConfirmSimple.vue'

export default Vue.extend({
  name: 'ItemCard',
  components: {
    ConfirmSimple,
  },
  props: {
    item: {
      type: Object as PropType<ProjectPage>,
      required: true,
    },
    showBookmarkAction: {
      type: Boolean,
      default: true,
    },
    showEditProjectIcon: {
      type: Boolean,
      default: false,
    },
    applicationStatus: {
      type: String,
      default: '',
    }
  },
  data: () => ({
    deleteProjectConfirmDialog: false,
  }),
  computed: {
    shouldShowBookmarkAction() {
      if (!this.showBookmarkAction) {
        return false;
      }

      // if (this.item.show) {
      //   return false;
      // }

      if ((this as any).item.author.isDeleted && !this.item.isFavourite) {
        return false;
      }

      return true;
    }
  },
  methods: {
    bookmarkProject: function () {
      if (!this.$store.state.authentication.signedIn) {
        this.$store.dispatch(
          'alert/info',
          'Register new account or sign in order to bookmark projects.'
        )
        return
      }

      this.$api
        .post('/likes/projects/' + this.item.id)
        .then((response: any) => {
          this.item.isFavourite = response.data.isLiked
          const message = response.data.isLiked
            ? 'Project has been added to your favourite projects.'
            : 'Project has been removed from your favourite projects.'
          this.$store.dispatch('alert/success', message)
          if (!response.data.isLiked) {
            this.$emit('bookmarkRemoved', this.item)
          }
        })
    },
  },
})
